import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { type Offering } from "@shared/types/localTypes/offerings";
import { PromotionItem } from "@shared/types/common";

export const useOfferingsStore = defineStore("offerings", () => {
  // State
  const _offerings = ref<Offering[]>([]);
  const _promotions = ref<PromotionItem[]>([]);

  // Getters
  const offerings = computed(() => _offerings.value);
  const promotions = computed(() => _promotions.value);

  // Actions
  const setOfferings = async (newOfferings: Offering[]) => {
    _offerings.value = newOfferings;
  };

  const setPromotions = async (newPromotions: PromotionItem[]) => {
    _promotions.value = newPromotions;
  };

  return {
    offerings,
    promotions,
    setOfferings,
    setPromotions,
  };
});
